<template>
  <Transition name="compare-bar">
    <div
      v-if="isVisible"
      class="fixed bottom-0 inset-x-0 z-40 bg-default border-t border-default shadow-lg"
    >
      <div class="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div class="flex items-center gap-3 overflow-x-auto">
          <span class="text-sm font-medium text-toned shrink-0">
            Compară ({{ compareIds.length }}/4):
          </span>
          <div
            v-for="id in compareIds"
            :key="id"
            class="flex items-center gap-2 bg-muted rounded-lg px-3 py-1.5 shrink-0 max-w-[220px]"
          >
            <span
              class="text-sm text-highlighted truncate"
              :title="compareLabels[id] || undefined"
            >
              {{ compareLabels[id] || `Produs #${id}` }}
            </span>
            <UButton
              icon="i-heroicons-x-mark"
              variant="ghost"
              color="neutral"
              size="xs"
              :padded="false"
              :aria-label="`Elimină ${compareLabels[id] || `produs #${id}`} din comparare`"
              @click="cartStore.toggleCompare(id)"
            />
          </div>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <UButton
            label="Golește"
            variant="ghost"
            color="neutral"
            size="sm"
            @click="cartStore.clearCompare()"
          />
          <UButton
            label="Compară acum"
            color="primary"
            size="sm"
            :to="comparePath"
          />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import type { Product } from '~/types'

const cartStore = useCartStore()
const { get } = useApi()
const { comparePath } = useCompare()
const compareIds = computed(() => cartStore.compareProducts)
const isVisible = computed(() => compareIds.value.length > 0)
const compareLabels = ref<Record<number, string>>({})

watch(compareIds, async (ids) => {
  if (!ids.length) {
    compareLabels.value = {}
    return
  }

  try {
    const response = await get<Product[]>(`/products/compare?ids=${ids.join(',')}`)
    if (!response.success || !response.data) return

    const labels: Record<number, string> = {}
    for (const product of response.data) {
      labels[product.id] = product.name
    }
    compareLabels.value = labels
  } catch {
    compareLabels.value = {}
  }
}, { immediate: true })
</script>

<style scoped>
.compare-bar-enter-active,
.compare-bar-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.compare-bar-enter-from,
.compare-bar-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
